<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.signMatter" label="会签事项" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.number" label="编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="经办人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorDeptName" label="经办部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.projectName" label="项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.talkDepNAme" label="洽谈部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractYiName" label="对方单位" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.buyReason" label="采购事由" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalAmountTax" label="总金额" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; margin-bottom: 10px; margin-top: 10px">
          <p style="display: block; color: #4caedc" @click="viewLxcgDetail()">查看明细</p>
        </div>
        <van-field v-model="inputForm.materialRecycle" label="旧材料回收" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.otherMatter" label="其他事项" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
          <p style="color: #AAA">附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
export default {
  name: "lxcg",
  data(){
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)

    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/hq/sign/approval/lxcg/queryById').then(({ data }) => {
        this.inputForm = data
        this.inputForm.dateRange = data.usedStartDate + '~' + data.usedEndDate
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/hq/sign/approval/lxcg/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey
          }
          _this.$flow.startFlow(form, '/hq/sign/approval/lxcg/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
    viewLxcgDetail(){
      this.$router.push({
        path: '/lxcgDetail',
        query: {
          data: JSON.stringify(this.inputForm.purchases)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>